<script setup>
import { ref, computed, inject } from 'vue'
import { useHead } from '@unhead/vue'

useHead({
  title: `${import.meta.env.VITE_BRAND_NAME} | 404 Not Found`,
  meta: [{ name: 'robots', content: 'noindex' }],
})
</script>

<template>
  <div>
    404 - Not found.
    <router-link to="/"
      ><span class="underline underline-offset-4"
        >Click here to go back to the homepage.
      </span></router-link
    >
  </div>
</template>
